import styled from "styled-components";

export const PoHistoryWrapper = styled.div`
.delete-icon{
  color: ${({ theme }) => theme['danger-hover']};
  font-size: 16px;
  cursor: pointer;
  margin-left: 10px;
}
.bar-item {
    display: flex;
    justify-content: space-between;
    border: 1px solid ${({ theme }) => theme['secondary-color']};
    padding: 12px;
    border-radius: 4px;
    margin-bottom: 24px;
    align-items: center;
    .search {
      width: 264px;
      input{
        padding-right: 32px;
      }
    }
    
    button {
      margin: 0;
      width: 512px;
    }
    .po-inputs {
      display: flex;
      align-items: center;
      gap: 12px;
      max-width: 919px;
    }
}
.crate-po-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: baseline;
    grid-gap: 16px;
}
`; 

export const ModalWrapper = styled.div`
.delete-modal-wrapper{
display:flex;
flex-direction:column;
align-items: center;
justify-content:space-between;
}`